import React, { useEffect, useState } from "react";
import PageTitle from "../../../jsx/layouts/PageTitle";
import { Modal, Button, Form, Badge } from "react-bootstrap";

const RoleManagement = () => {
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [pages, setPages] = useState([]);
  const [message, setMessage] = useState("");

  const currentEmail = localStorage.getItem("userEmail");

  const [userForm, setUserForm] = useState({
    email: "",
    password: "",
    role: "",
  });

  const [roleForm, setRoleForm] = useState({
    role_name: "",
    allowed_pages: [],
  });

  const [editUser, setEditUser] = useState(null);
  const [editRole, setEditRole] = useState(null);
  const [deleteUserData, setDeleteUserData] = useState(null);
  const [deleteRoleData, setDeleteRoleData] = useState(null);

  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [showAddRoleModal, setShowAddRoleModal] = useState(false);
  const [showEditUserModal, setShowEditUserModal] = useState(false);
  const [showEditRoleModal, setShowEditRoleModal] = useState(false);
  const [showDeleteUserModal, setShowDeleteUserModal] = useState(false);
  const [showDeleteRoleModal, setShowDeleteRoleModal] = useState(false);

  useEffect(() => {
    fetchUsers();
    fetchRoles();
    fetchPages();
  }, []);

  const fetchUsers = async () => {
    const res = await fetch("https://admin.drgargevascular.com/backend/users");
    const data = await res.json();
    setUsers(Array.isArray(data) ? data : []);
  };

  const fetchRoles = async () => {
    const res = await fetch("https://admin.drgargevascular.com/backend/roles");
    const data = await res.json();
    setRoles(Array.isArray(data) ? data : []);
  };

  const fetchPages = async () => {
    const res = await fetch("https://admin.drgargevascular.com/backend/dashboard-pages");
    const data = await res.json();
    setPages(Array.isArray(data) ? data : []);
  };

  const showAlert = (msg) => {
    setMessage(msg);
    setTimeout(() => setMessage(""), 3000);
  };

  const handleUserChange = (e) => {
    setUserForm({
      ...userForm,
      [e.target.name]: e.target.value,
    });
  };

  const handleRoleChange = (e) => {
    setRoleForm({
      ...roleForm,
      [e.target.name]: e.target.value,
    });
  };

  const handleRolePageToggle = (pageKey) => {
    const exists = roleForm.allowed_pages.includes(pageKey);

    setRoleForm({
      ...roleForm,
      allowed_pages: exists
        ? roleForm.allowed_pages.filter((p) => p !== pageKey)
        : [...roleForm.allowed_pages, pageKey],
    });
  };

  const handleEditRolePageToggle = (pageKey) => {
    const exists = editRole.allowed_pages.includes(pageKey);

    setEditRole({
      ...editRole,
      allowed_pages: exists
        ? editRole.allowed_pages.filter((p) => p !== pageKey)
        : [...editRole.allowed_pages, pageKey],
    });
  };

  const createUser = async (e) => {
    e.preventDefault();

    const res = await fetch("https://admin.drgargevascular.com/backend/register", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userForm),
    });

    const data = await res.json();

    if (res.ok) {
      showAlert("User created successfully");
      setUserForm({ email: "", password: "", role: "" });
      setShowAddUserModal(false);
      fetchUsers();
    } else {
      showAlert(data.message || "Failed to create user");
    }
  };

  const createRole = async (e) => {
    e.preventDefault();

    const res = await fetch("https://admin.drgargevascular.com/backend/roles", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(roleForm),
    });

    const data = await res.json();

    if (res.ok) {
      showAlert("Role created successfully");
      setRoleForm({ role_name: "", allowed_pages: [] });
      setShowAddRoleModal(false);
      fetchRoles();
    } else {
      showAlert(data.message || "Failed to create role");
    }
  };

  const updateUserRole = async () => {
    const res = await fetch(`https://admin.drgargevascular.com/backend/users/${editUser.id}/role`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ role: editUser.role }),
    });

    if (res.ok) {
      showAlert("User role updated successfully");
      setShowEditUserModal(false);
      fetchUsers();
    } else {
      showAlert("Failed to update user role");
    }
  };

  const updateRole = async () => {
    const res = await fetch(`https://admin.drgargevascular.com/backend/roles/${editRole.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(editRole),
    });

    if (res.ok) {
      showAlert("Role updated successfully");
      setShowEditRoleModal(false);
      fetchRoles();
    } else {
      showAlert("Failed to update role");
    }
  };

  const confirmDeleteUser = async () => {
    const res = await fetch(`https://admin.drgargevascular.com/backend/users/${deleteUserData.id}`, {
      method: "DELETE",
    });

    if (res.ok) {
      showAlert("User deleted successfully");
      setShowDeleteUserModal(false);
      fetchUsers();
    } else {
      showAlert("Failed to delete user");
    }
  };

  const confirmDeleteRole = async () => {
    const res = await fetch(`https://admin.drgargevascular.com/backend/roles/${deleteRoleData.id}`, {
      method: "DELETE",
    });

    const data = await res.json();

    if (res.ok) {
      showAlert("Role deleted successfully");
      setShowDeleteRoleModal(false);
      fetchRoles();
    } else {
      showAlert(data.message || "Failed to delete role");
    }
  };

  return (
    <>
      <PageTitle activeMenu="Role Management" motherMenu="Dashboard" />

      <div className="row">
        <div className="col-xl-12 mb-4">
          {message && <div className="alert alert-info">{message}</div>}
        </div>

        {/* USERS */}
        <div className="col-xl-12 mb-4">
          <div className="card shadow-sm border-0 rounded-4">
            <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center">
              <div>
                <h4 className="mb-0 fw-bold">Users</h4>
                <small className="text-muted">Create and manage login users</small>
              </div>

              <button className="btn btn-primary" onClick={() => setShowAddUserModal(true)}>
                Add User
              </button>
            </div>

            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>ID</th>
                      <th>Email</th>
                      <th>Role</th>
                      <th>Created</th>
                      <th className="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((user) => (
                      <tr key={user.id}>
                        <td>{user.id}</td>
                        <td>{user.email}</td>
                        <td><Badge bg="secondary">{user.role}</Badge></td>
                        <td>{new Date(user.createdAt).toLocaleDateString()}</td>
                        <td className="text-center">
                          <button
                            className="btn btn-warning btn-sm me-2"
                            disabled={user.email === currentEmail}
                            onClick={() => {
                              setEditUser(user);
                              setShowEditUserModal(true);
                            }}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-danger btn-sm"
                            disabled={user.email === currentEmail}
                            onClick={() => {
                              setDeleteUserData(user);
                              setShowDeleteUserModal(true);
                            }}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                    {users.length === 0 && (
                      <tr>
                        <td colSpan="5" className="text-center">No users found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* ROLES */}
        <div className="col-xl-12">
          <div className="card shadow-sm border-0 rounded-4">
            <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center">
              <div>
                <h4 className="mb-0 fw-bold">Custom Roles & Permissions</h4>
                <small className="text-muted">Create roles and assign page access</small>
              </div>

              <button className="btn btn-primary" onClick={() => setShowAddRoleModal(true)}>
                Add Role
              </button>
            </div>

            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>ID</th>
                      <th>Role Name</th>
                      <th>Allowed Pages</th>
                      <th className="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {roles.map((role) => (
                      <tr key={role.id}>
                        <td>{role.id}</td>
                        <td><Badge bg="dark">{role.role_name}</Badge></td>
                        <td>
                          {role.allowed_pages?.map((page) => (
                            <Badge key={page} bg="info" className="me-1 mb-1">
                              {page}
                            </Badge>
                          ))}
                        </td>
                        <td className="text-center">
                          <button
                            className="btn btn-warning btn-sm me-2"
                            onClick={() => {
                              setEditRole(role);
                              setShowEditRoleModal(true);
                            }}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-danger btn-sm"
                            disabled={role.role_name === "admin"}
                            onClick={() => {
                              setDeleteRoleData(role);
                              setShowDeleteRoleModal(true);
                            }}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                    {roles.length === 0 && (
                      <tr>
                        <td colSpan="4" className="text-center">No roles found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ADD USER MODAL */}
      <Modal show={showAddUserModal} onHide={() => setShowAddUserModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add User</Modal.Title>
        </Modal.Header>
        <Form onSubmit={createUser}>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control name="email" value={userForm.email} onChange={handleUserChange} required />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <Form.Control type="password" name="password" value={userForm.password} onChange={handleUserChange} required />
            </Form.Group>

            <Form.Group>
              <Form.Label>Select Role</Form.Label>
              <Form.Select name="role" value={userForm.role} onChange={handleUserChange} required>
                <option value="">Select Role</option>
                {roles.map((role) => (
                  <option key={role.id} value={role.role_name}>
                    {role.role_name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowAddUserModal(false)}>Cancel</Button>
            <Button variant="primary" type="submit">Create User</Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* ADD ROLE MODAL */}
      <Modal show={showAddRoleModal} onHide={() => setShowAddRoleModal(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Add Role</Modal.Title>
        </Modal.Header>
        <Form onSubmit={createRole}>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Role Name</Form.Label>
              <Form.Control
                name="role_name"
                value={roleForm.role_name}
                onChange={handleRoleChange}
                placeholder="Example: seo-manager"
                required
              />
            </Form.Group>

            <Form.Label>Allowed Pages</Form.Label>
            <div className="row">
              {pages.map((page) => (
                <div className="col-md-4 mb-2" key={page.key}>
                  <Form.Check
                    type="checkbox"
                    label={page.label}
                    checked={roleForm.allowed_pages.includes(page.key)}
                    onChange={() => handleRolePageToggle(page.key)}
                  />
                </div>
              ))}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowAddRoleModal(false)}>Cancel</Button>
            <Button variant="primary" type="submit">Create Role</Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* EDIT USER MODAL */}
      <Modal show={showEditUserModal} onHide={() => setShowEditUserModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit User Role</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editUser && (
            <>
              <p><strong>Email:</strong> {editUser.email}</p>
              <Form.Group>
                <Form.Label>Select Role</Form.Label>
                <Form.Select
                  value={editUser.role}
                  onChange={(e) => setEditUser({ ...editUser, role: e.target.value })}
                >
                  {roles.map((role) => (
                    <option key={role.id} value={role.role_name}>
                      {role.role_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditUserModal(false)}>Cancel</Button>
          <Button variant="warning" onClick={updateUserRole}>Save Changes</Button>
        </Modal.Footer>
      </Modal>

      {/* EDIT ROLE MODAL */}
      <Modal show={showEditRoleModal} onHide={() => setShowEditRoleModal(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Edit Role</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editRole && (
            <>
              <Form.Group className="mb-3">
                <Form.Label>Role Name</Form.Label>
                <Form.Control
                  value={editRole.role_name}
                  onChange={(e) => setEditRole({ ...editRole, role_name: e.target.value })}
                  disabled={editRole.role_name === "admin"}
                />
              </Form.Group>

              <Form.Label>Allowed Pages</Form.Label>
              <div className="row">
                {pages.map((page) => (
                  <div className="col-md-4 mb-2" key={page.key}>
                    <Form.Check
                      type="checkbox"
                      label={page.label}
                      checked={editRole.allowed_pages.includes(page.key)}
                      onChange={() => handleEditRolePageToggle(page.key)}
                    />
                  </div>
                ))}
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditRoleModal(false)}>Cancel</Button>
          <Button variant="warning" onClick={updateRole}>Save Changes</Button>
        </Modal.Footer>
      </Modal>

      {/* DELETE USER MODAL */}
      <Modal show={showDeleteUserModal} onHide={() => setShowDeleteUserModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {deleteUserData && (
            <p>Are you sure you want to delete <strong>{deleteUserData.email}</strong>?</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteUserModal(false)}>Cancel</Button>
          <Button variant="danger" onClick={confirmDeleteUser}>Yes, Delete</Button>
        </Modal.Footer>
      </Modal>

      {/* DELETE ROLE MODAL */}
      <Modal show={showDeleteRoleModal} onHide={() => setShowDeleteRoleModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete Role</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {deleteRoleData && (
            <p>Are you sure you want to delete role <strong>{deleteRoleData.role_name}</strong>?</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteRoleModal(false)}>Cancel</Button>
          <Button variant="danger" onClick={confirmDeleteRole}>Yes, Delete</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RoleManagement;